<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import '@/assets/css/common.css'
export default {
  name: 'App',
  beforeCreate(){ 

  },
 
    mounted(){
      this.$store.commit("changeMsg",true);
    },

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  /* background-color: #001928; */
  background: url(./assets/img/bg.jpg) repeat;
  /* background-size: 100% 100%; */
  /* -moz-user-select: none; 
  -webkit-user-select: none; 
  -ms-user-select: none; 
  -khtml-user-select: none; 
  -o-user-select:none;
  user-select: none; */

  overflow-x: hidden;
  min-width: 1280px;
}
html,body {
  height: 100%;
}
/* ::-webkit-scrollbar {
  display: none
} */
</style>
